import React from 'react';
import classNames from 'classnames';

interface Props {
  onPress: () => void;
  icon: React.ReactNode;
  title: string;
  selectedSubtitle?: string;
  children?: React.ReactNode;
  selected?: boolean;
  disabled?: boolean;
}

function PaymentOption({
  onPress,
  icon,
  title,
  selectedSubtitle,
  children,
  selected,
  disabled
}: Props) {
  return (
    <div
      onClick={disabled ? undefined : onPress}
      className={classNames(
        'flex items-center py-2 px-5 rounded-full border-2 border-gray-200 w-full min-h-[56px]',
        !disabled && selected ? 'border-gray-600' : 'border-gray-200',
        disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer  hover:border-gray-600'
      )}
    >
      <div className="w-[37px] mr-2">{icon}</div>
      <div className="flex flex-1 flex-col items-start">
        <span className="text-base font-bold text-gray-700">{title}</span>
        {selectedSubtitle && selected && (
          <span className="text-sm font-normal text-gray-500">
            {selectedSubtitle}
          </span>
        )}
        {children}
      </div>
      <div
        className={classNames(
          'border-2 rounded-full h-[20px] w-[20px] flex items-center justify-center',
          selected ? 'border-primary-500' : 'border-gray-600'
        )}
      >
        {selected && (
          <div className="w-[10px] h-[10px] bg-primary-500 rounded-full" />
        )}
      </div>
    </div>
  );
}

export default PaymentOption;
